module.exports = __webpack_public_path__ + "img/SRLF_logo.95029d72.jpg";